import cfg, {handleResponse, handlePrepareData} from "../constants";
import {authMiddleware} from "./loginAction";

export const getQuickAnswerAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/quick-answer/' + id, {
    method: "GET",
    headers: headers
  }).then(handleResponse).then(handlePrepareData);
};

export const deleteQuickAnswerAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/quick-answer/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const updateQuickAnswerAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/quick-answer', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};

export const getListQuickAnswersAction = (filter) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/quick-answers', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(filter)
  }).then(handleResponse).then(handlePrepareData);
};

export const getQuickAnswerAddRatingAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/quick-answer-add-rating/' + id, {
    method: "GET",
    headers: headers
  }).then(handleResponse).then(handlePrepareData);
};
